// If restore in Freespin (Not on the first freespin), the Intro will do the restore work but not show.
// When restore on the first freespin (the round winning Freespin), show the Intro.


import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {TimelineLite} from "gsap";
import {TractorBeamBackgroundEvent} from "../../background/TractorBeamBackground";

export class TractorBeamFreeSpinOutroController extends FreespinOutroController {

    constructor(config:IScreenConfig) {
        super(config);
    }

    /*protected show():boolean {
        //TractorBeamGameModuleConfig.soundPlayer.switchToMainMusic();
        EventHandler.dispatchEvent(new GameEvent(TractorBeamBackgroundEvent.TOGGLE_COMMAND_CENTER, false));
        //TractorBeamGameModuleConfig.background.zoomAndPane(false);
        return super.show();
    }*/

    protected show():boolean {
        if(this.shouldShow()) {
            EventHandler.dispatchEvent(new GameEvent(TractorBeamBackgroundEvent.TOGGLE_COMMAND_CENTER, false));
            this._view.show(this._serverData!, () => this.onShowComplete());
            SlotGame.keypad.setZeroBetSpinCounter(-1);
            this.hideKeypad();
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            //EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
            this._isShowing = true;
        }

        // When restore in freespin, don't show the intro but we need the intro to init the freespin scene.
        if(this.doTransitions) {
            this.doTransitions();
        }

        return this._isShowing;
    }

    protected onCloseComplete():void {
        SlotGame.winFieldController.showWinField();
        //EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));

        new TimelineLite().add(() => {
            EventHandler.dispatchEvent(new GameEvent(ScreenEvent.SCREEN_CLOSED));
            this.showKeypad();
        }, 1.3);
    }
}
